"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyResets = exports.createText = void 0;
var _react = require("react");
require("./createText.css");
var _useTextTransform = require("@cbhq/cds-common/hooks/useTextTransform");
var _isChildrenFalsy = require("@cbhq/cds-common/utils/isChildrenFalsy");
var _cdsUtils = require("@cbhq/cds-utils");
var _useResponsiveConfig = require("../hooks/useResponsiveConfig");
var _useSpacingStyles = require("../hooks/useSpacingStyles");
var _disabledState = require("../styles/disabledState");
var foregroundStyles = _interopRequireWildcard(require("../styles/foregroundColor"));
var _responsive = require("../styles/responsive");
var _typography = require("../styles/typography");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
var _useTypographyStyles = require("./useTypographyStyles");
const _excluded = ["as", "children", "color", "align", "display", "tabularNumbers", "slashedZero", "selectable", "underline", "mono", "noWrap", "numberOfLines", "overflow", "testID", "transform", "className", "inherit", "spacing", "spacingTop", "spacingBottom", "spacingStart", "spacingEnd", "spacingVertical", "spacingHorizontal", "disabled", "dangerouslySetColor", "accessibilityLabel", "accessibilityLabelledBy", "id", "responsiveConfig", "strikethroughStartAccessibilityLabel", "strikethroughEndAccessibilityLabel"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const typographyResets = "cds-typographyResets-t1xhpuq2";
exports.typographyResets = typographyResets;
const currentColor = "cds-currentColor-cl6elq7";
const textInherit = "cds-textInherit-t1yzihzw";

/** Strikesthrough element accessibility implementation
 * @link: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/s#accessibility_concerns
 */
const strikethrough = "cds-strikethrough-s1nthu85";
const createText = (name, overrides) => {
  const TextComponent = (_ref, ref) => {
    var _overrides$color, _overrides$align, _overrides$strikethro, _overrides$strikethro2, _overrides$as;
    let as = _ref.as,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.children : _ref$children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? (_overrides$color = overrides === null || overrides === void 0 ? void 0 : overrides.color) !== null && _overrides$color !== void 0 ? _overrides$color : 'foreground' : _ref$color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? (_overrides$align = overrides === null || overrides === void 0 ? void 0 : overrides.align) !== null && _overrides$align !== void 0 ? _overrides$align : 'start' : _ref$align,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.display : _ref$display,
      _ref$tabularNumbers = _ref.tabularNumbers,
      tabularNumbers = _ref$tabularNumbers === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.tabularNumbers : _ref$tabularNumbers,
      _ref$slashedZero = _ref.slashedZero,
      slashedZero = _ref$slashedZero === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.slashedZero : _ref$slashedZero,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.selectable : _ref$selectable,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.underline : _ref$underline,
      _ref$mono = _ref.mono,
      mono = _ref$mono === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.mono : _ref$mono,
      _ref$noWrap = _ref.noWrap,
      noWrap = _ref$noWrap === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.noWrap : _ref$noWrap,
      _ref$numberOfLines = _ref.numberOfLines,
      numberOfLines = _ref$numberOfLines === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.numberOfLines : _ref$numberOfLines,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.overflow : _ref$overflow,
      _ref$testID = _ref.testID,
      testID = _ref$testID === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.testID : _ref$testID,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.transform : _ref$transform,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.className : _ref$className,
      _ref$inherit = _ref.inherit,
      inherit = _ref$inherit === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.inherit : _ref$inherit,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacing : _ref$spacing,
      _ref$spacingTop = _ref.spacingTop,
      spacingTop = _ref$spacingTop === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingTop : _ref$spacingTop,
      _ref$spacingBottom = _ref.spacingBottom,
      spacingBottom = _ref$spacingBottom === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingBottom : _ref$spacingBottom,
      _ref$spacingStart = _ref.spacingStart,
      spacingStart = _ref$spacingStart === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingStart : _ref$spacingStart,
      _ref$spacingEnd = _ref.spacingEnd,
      spacingEnd = _ref$spacingEnd === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingEnd : _ref$spacingEnd,
      _ref$spacingVertical = _ref.spacingVertical,
      spacingVertical = _ref$spacingVertical === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingVertical : _ref$spacingVertical,
      _ref$spacingHorizonta = _ref.spacingHorizontal,
      spacingHorizontal = _ref$spacingHorizonta === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.spacingHorizontal : _ref$spacingHorizonta,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.disabled : _ref$disabled,
      _ref$dangerouslySetCo = _ref.dangerouslySetColor,
      dangerouslySetColor = _ref$dangerouslySetCo === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.dangerouslySetColor : _ref$dangerouslySetCo,
      _ref$accessibilityLab = _ref.accessibilityLabel,
      accessibilityLabel = _ref$accessibilityLab === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.accessibilityLabel : _ref$accessibilityLab,
      _ref$accessibilityLab2 = _ref.accessibilityLabelledBy,
      accessibilityLabelledBy = _ref$accessibilityLab2 === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.accessibilityLabelledBy : _ref$accessibilityLab2,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? overrides === null || overrides === void 0 ? void 0 : overrides.id : _ref$id,
      responsiveConfig = _ref.responsiveConfig,
      _ref$strikethroughSta = _ref.strikethroughStartAccessibilityLabel,
      strikethroughStartAccessibilityLabel = _ref$strikethroughSta === void 0 ? (_overrides$strikethro = overrides === null || overrides === void 0 ? void 0 : overrides.strikethroughStartAccessibilityLabel) !== null && _overrides$strikethro !== void 0 ? _overrides$strikethro : '[start of stricken text]' : _ref$strikethroughSta,
      _ref$strikethroughEnd = _ref.strikethroughEndAccessibilityLabel,
      strikethroughEndAccessibilityLabel = _ref$strikethroughEnd === void 0 ? (_overrides$strikethro2 = overrides === null || overrides === void 0 ? void 0 : overrides.strikethroughEndAccessibilityLabel) !== null && _overrides$strikethro2 !== void 0 ? _overrides$strikethro2 : '[end of stricken text]' : _ref$strikethroughEnd,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const typographyStyles = (0, _useTypographyStyles.useTypographyStyles)(name);
    const textTransform = (0, _useTextTransform.useTextTransform)(name, transform);
    const spacingStyles = (0, _useSpacingStyles.useSpacingStyles)({
      spacing,
      spacingTop,
      spacingBottom,
      spacingStart,
      spacingEnd,
      spacingVertical,
      spacingHorizontal
    });
    const responsiveStyleClassNames = (0, _useResponsiveConfig.useResponsiveConfig)(responsiveConfig);
    const elementType = (_overrides$as = overrides === null || overrides === void 0 ? void 0 : overrides.as) !== null && _overrides$as !== void 0 ? _overrides$as : as;
    const textStyles = (0, _react.useMemo)(() => {
      const style = {};
      if (dangerouslySetColor) {
        style.color = dangerouslySetColor;
      }
      if (numberOfLines) {
        style['--typography-number-of-lines'] = numberOfLines;
      }
      return style;
    }, [dangerouslySetColor, numberOfLines]);
    if ((0, _isChildrenFalsy.isChildrenFalsy)(children)) {
      return null;
    }
    return /*#__PURE__*/(0, _react.createElement)(elementType, Object.assign({}, props, {
      'data-testid': testID,
      'aria-label': accessibilityLabel,
      'aria-labelledby': accessibilityLabelledBy,
      id,
      ref
    }, mono ? {
      'data-variant': 'mono'
    } : _cdsUtils.emptyObject, elementType === 's' ? {
      'data-strikethrough-start': strikethroughStartAccessibilityLabel,
      'data-strikethrough-end': strikethroughEndAccessibilityLabel
    } : _cdsUtils.emptyObject, {
      style: textStyles,
      className: (0, _linaria.cx)(typographyResets, inherit ? textInherit : typographyStyles, color === 'currentColor' ? currentColor : foregroundStyles[color], disabled && _disabledState.disabledState, elementType === 's' && strikethrough, ...(0, _typography.getTypographyStyles)({
        align,
        display,
        tabularNumbers,
        slashedZero,
        selectable,
        underline,
        noWrap,
        numberOfLines,
        overflow,
        transform: textTransform
      }), spacingStyles, responsiveStyleClassNames, responsiveConfig && _responsive.responsiveClassName, className)
    }), children);
  };

  /**
   * Works around issue DX-2953, an unintentional breaking type change introduced
   * in v5.16.4 here https://github.cbhq.net/frontend/cds/pull/2366 which caused
   * components created by createText to stop inheriting prop types when using
   * polymorphic `as` prop. For example, <TextBody as="time" /> was not inheriting
   * types for the `dateTime` prop.
   * Read more about forwardRef generic types here
   * https://www.benmvp.com/blog/forwarding-refs-polymorphic-react-component-typescript/
   */

  const TextComponentWithRef = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(TextComponent));
  TextComponentWithRef.displayName = `Text${(0, _cdsUtils.pascalCase)(name)}`;
  return TextComponentWithRef;
};
exports.createText = createText;